import * as React from "react";
import { connect } from "react-redux";
import CreditNotes from "../../screens/CreditNotes";

import {
  CreditNote,
  CreditNotesSlectedPage,
  CreditNoteSearch,
  CreditNoteSearchSelectedPage
} from "./action";
class CreditNotesContainer extends React.Component<Props, State> {
  render() {
    return (
      <CreditNotes
        CreditNote={this.props.CreditNote}
        CreditNotesDtlsList={this.props.CreditNotesDtlsList}
        CreditNoteslsCount={this.props.CreditNoteslsCount}
        CreditNotesSlectedPage={this.props.CreditNotesSlectedPage}
        CreditNoteSearch={this.props.CreditNoteSearch}
        CreditNoteSearchSelectedPage={this.props.CreditNoteSearchSelectedPage}
        CreditNotesSearchList={this.props.CreditNotesSearchList}
        CreditNotesSearchCount={this.props.CreditNotesSearchCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    CreditNote: () => {
      dispatch(CreditNote());
    },
    CreditNotesSlectedPage: value => {
      dispatch(CreditNotesSlectedPage(value));
    },
    CreditNoteSearch: value => {
      dispatch(CreditNoteSearch(value));
    },
    CreditNoteSearchSelectedPage: value => {
      dispatch(CreditNoteSearchSelectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    CreditNotesDtlsList: state.CreditNotesReducer.CreditNotesDtlsList,
    CreditNoteslsCount: state.CreditNotesReducer.CreditNoteslsCount,
    CreditNotesSearchList: state.CreditNotesReducer.CreditNotesSearchList,
    CreditNotesSearchCount: state.CreditNotesReducer.CreditNotesSearchCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(CreditNotesContainer);
